import React, { forwardRef } from 'react';
import { Checkbox, Row, Col, Tooltip, Icon } from 'antd';

const CheckboxGroup = Checkbox.Group;

const Group = forwardRef(({ items, value, onChange }, ref) => {
  const itemsLen = items?.length || 0;
  const valueLen = value?.length || 0;

  return (
    <div ref={ref}>
      {itemsLen > 1 && (
        <Checkbox
          onChange={({ target }) =>
            onChange(target.checked ? items.map(({ id }) => id) : [])
          }
          checked={valueLen === itemsLen}
          indeterminate={Boolean(valueLen && valueLen < itemsLen)}
        >
          Все
        </Checkbox>
      )}
      <CheckboxGroup
        style={{ width: '100%' }}
        value={value}
        onChange={onChange}
      >
        {(items || []).map((item) => (
          <Row key={item.id}>
            <Col span={24}>
              <Checkbox value={item.id}>
                {item.name}&nbsp;
                <Tooltip title={item.description || ''}>
                  <Icon type="info-circle" />
                </Tooltip>
              </Checkbox>
            </Col>
          </Row>
        ))}
      </CheckboxGroup>
    </div>
  );
});

export default Group;
